ko.bindingHandlers["clearingForeach"] =
   init: (element, valueAccessor, allBindings, viewModel, context) ->
      return ko.bindingHandlers.foreach.init(element, valueAccessor, allBindings, viewModel, context)

   update: (element, valueAccessor, allBindings, viewModel, context) ->
      $(element).empty()
      # This is here to force the update function to see the data as a true update even if just reorded.
      ko.bindingHandlers.foreach.update(element, ko.observable([]), allBindings, viewModel, context)
      return ko.bindingHandlers.foreach.update(element, valueAccessor, allBindings, viewModel, context)